import { isBrowser } from './environment';

const isLinkpulseLoaded: () => boolean = () => isBrowser() && window.LP4;

export const logPageview = (data: { title: string; image?: string; url?: string }): void => {
    if (isLinkpulseLoaded()) {
        window.LP4.logPageview(data);
    }
};

export const setUrl = (url: string): void => {
    if (isLinkpulseLoaded()) {
        window.LP4.setUrl(url);
    }
};
